import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, ChevronRight, FileText, PanelsTopLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, StageBadge } from "@/components/Layout";
import { api } from "@/lib/api";

export default function Campaigns() {
  const [camps, setCamps] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/campaigns").then((r) => setCamps(r.data)); }, []);
  const create = async () => {
    const name = window.prompt("Campaign name", "New campaign");
    if (!name) return;
    const { data } = await api.post("/campaigns", { name, starter: true });
    nav(`/campaigns/${data.id}`);
  };
  return (
    <div>
      <PageHeader eyebrow="Email automation" title="Campaigns">
        <Link to="/templates?campaign=shared"><Button variant="outline" data-testid="shared-templates-btn"><FileText size={15} className="mr-1" />Shared templates</Button></Link>
        <Link to="/landing-pages?campaign=shared"><Button variant="outline" data-testid="shared-lps-btn"><PanelsTopLeft size={15} className="mr-1" />Shared landing pages</Button></Link>
        <Button onClick={create} data-testid="new-campaign-btn"><Plus size={15} className="mr-1" />New campaign</Button></PageHeader>
      <div className="p-6 lg:p-10 grid gap-3">
        {camps.map((c) => (
          <Link key={c.id} to={`/campaigns/${c.id}`} className="bg-white border rounded-xl p-5 card-lift flex flex-wrap items-center gap-6" data-testid={`campaign-card-${c.id}`}>
            <div className="flex-1 min-w-[240px]">
              <div className="flex items-center gap-2"><h3 className="font-bold text-lg">{c.name}</h3>
                <span className={`text-[10px] uppercase font-semibold rounded px-1.5 py-0.5 ${c.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>{c.status}</span></div>
              <div className="text-sm text-slate-500">{c.description}</div>
              <div className="flex flex-wrap gap-1.5 mt-3">{c.steps.map((s, i) => <StageBadge key={i} stage={s.stage} />)}</div>
              <div className="text-xs text-slate-500 mt-2" data-testid={`campaign-assets-${c.id}`}>{c.templates ?? 0} email template{c.templates === 1 ? "" : "s"} · {c.pages ?? 0} landing page{c.pages === 1 ? "" : "s"}</div>
            </div>
            <div className="flex gap-6 font-mono text-sm">
              <div><div className="text-2xl font-extrabold font-sans">{c.leads}</div><div className="label-xs">leads</div></div>
              <div><div className="text-2xl font-extrabold font-sans">{c.active}</div><div className="label-xs">active</div></div>
              <div><div className="text-2xl font-extrabold font-sans">{c.sent}</div><div className="label-xs">sent</div></div>
            </div>
            <ChevronRight className="text-slate-300" />
          </Link>
        ))}
      </div>
    </div>
  );
}
